/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExperienceDay } from '../../models/experience-day';

export interface GetExperienceDay$Params {
  id: string;
}

export function getExperienceDay(http: HttpClient, rootUrl: string, params: GetExperienceDay$Params, context?: HttpContext): Observable<StrictHttpResponse<ExperienceDay>> {
  const rb = new RequestBuilder(rootUrl, getExperienceDay.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExperienceDay>;
    })
  );
}

getExperienceDay.PATH = '/experienceday/{id}';
